export default __webpack_public_path__ + "static/media/ic-dashboard-icon.f5d0c375.svg";